/* Navbar: mega-menú Soluciones (desktop hover + panel integrado / mobile sub-vista con Volver) */
(function () {
    const roots = document.querySelectorAll('[data-melo-nav-solutions]');
    if (!roots.length) {
        return;
    }

    const desktopMq = window.matchMedia('(min-width: 992px)');
    const navigation = document.getElementById('gh-navigation');

    function setSolutionsExpanded(root, expanded) {
        const trigger = root.querySelector('[data-melo-nav-solutions-trigger]');
        const panel = root.querySelector('[data-melo-nav-solutions-panel]');
        if (!trigger || !panel) {
            return;
        }

        const isAlready = root.classList.contains('is-open') === expanded;
        root.classList.toggle('is-open', expanded);
        trigger.classList.toggle('is-open', expanded);
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        panel.hidden = false;
        panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        if (!desktopMq.matches && expanded) {
            panel.scrollTop = 0;
        }

        if (navigation) {
            navigation.classList.toggle('melo-nav-solutions-open', expanded);
        }
        document.documentElement.classList.toggle('melo-nav-solutions-open', expanded);

        if (!isAlready && expanded) {
            document.dispatchEvent(new CustomEvent('melo-nav-solutions-open'));
        }
    }

    function closeAll(exceptRoot) {
        roots.forEach(function (root) {
            if (root !== exceptRoot && root.classList.contains('is-open')) {
                setSolutionsExpanded(root, false);
            }
        });
    }

    roots.forEach(function (root) {
        const trigger = root.querySelector('[data-melo-nav-solutions-trigger]');
        const panel = root.querySelector('[data-melo-nav-solutions-panel]');
        const backBtn = root.querySelector('[data-melo-nav-solutions-back]');
        if (!trigger || !panel) {
            return;
        }

        let hoverCloseTimer = null;

        function clearHoverCloseTimer() {
            if (hoverCloseTimer !== null) {
                window.clearTimeout(hoverCloseTimer);
                hoverCloseTimer = null;
            }
        }

        function scheduleHoverClose(delayMs) {
            clearHoverCloseTimer();
            hoverCloseTimer = window.setTimeout(function () {
                hoverCloseTimer = null;
                if (desktopMq.matches) {
                    setSolutionsExpanded(root, false);
                }
            }, typeof delayMs === 'number' ? delayMs : 140);
        }

        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'true');

        trigger.addEventListener('mouseenter', function () {
            if (!desktopMq.matches) {
                return;
            }
            clearHoverCloseTimer();
            closeAll(root);
            setSolutionsExpanded(root, true);
        });

        trigger.addEventListener('mouseleave', function () {
            if (!desktopMq.matches) {
                return;
            }
            scheduleHoverClose(150);
        });

        panel.addEventListener('mouseenter', function () {
            if (!desktopMq.matches) {
                return;
            }
            clearHoverCloseTimer();
        });

        panel.addEventListener('mouseleave', function () {
            if (!desktopMq.matches) {
                return;
            }
            scheduleHoverClose(140);
        });

        const siblingNavItems = root.querySelectorAll(
            '.melo-nav-dropdown-inner > .melo-nav-item:not([data-melo-nav-solutions-trigger]), .melo-nav-logo, .melo-nav-cluster-actions'
        );
        siblingNavItems.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
                if (!desktopMq.matches || !root.classList.contains('is-open')) {
                    return;
                }
                scheduleHoverClose(90);
            });
        });

        if (navigation) {
            navigation.addEventListener('mouseleave', function () {
                if (!desktopMq.matches || !root.classList.contains('is-open')) {
                    return;
                }
                scheduleHoverClose(110);
            });
        }

        trigger.addEventListener('click', function (event) {
            event.stopPropagation();
            clearHoverCloseTimer();
            const willOpen = !root.classList.contains('is-open');
            if (willOpen) {
                closeAll(root);
            }
            setSolutionsExpanded(root, willOpen);
        });

        if (backBtn) {
            backBtn.addEventListener('click', function (event) {
                event.stopPropagation();
                clearHoverCloseTimer();
                setSolutionsExpanded(root, false);
            });
        }

        panel.addEventListener('click', function (event) {
            if (!event.target.closest('a.melo-nav-solutions-link, a.melo-nav-solutions-aside-card-cta, .melo-nav-solutions-menu-footer a')) {
                return;
            }
            clearHoverCloseTimer();
            closeAll(null);
            document.dispatchEvent(new CustomEvent('melo-nav-request-close-menu'));
        });
    });

    document.addEventListener('click', function (event) {
        if (event.target.closest('[data-melo-nav-solutions]')) {
            return;
        }
        closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeAll(null);
        }
    });

    desktopMq.addEventListener('change', function () {
        closeAll(null);
        roots.forEach(function (root) {
            const panel = root.querySelector('[data-melo-nav-solutions-panel]');
            if (!panel) {
                return;
            }
            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'true');
        });
    });

    document.addEventListener('melo-nav-menu-closed', function () {
        closeAll(null);
    });

    document.addEventListener('melo-nav-lang-open', function () {
        closeAll(null);
    });
})();
